import { routeConstant } from "./routeConstant";
import Login from "pages/auth/login";
import ForgotPassword from "pages/auth/forgot-password";
import OnboardingFlow from "pages/auth/onboarding";
import DesignerHome from "pages/designer/home";
import DesignerProjects from "pages/designer/projects";
import UploadRevision from "pages/designer/home/uploadRevision";
import DesignerProjectDetail from "pages/designer/projects/projectDetail";
import DesignerChatThread from "pages/designer/projects/chatThread";
import DesignerNotifications from "pages/designer/notifications";
import DesignerAccountSetting from "pages/designer/account-setting";
import ClientProjects from "pages/client/projects";
import ClientArchivedProjects from "pages/client/archivedProjects";
import ClientProjectDetail from "pages/client/projects/projectDetail";
import ClientDocuments from "pages/client/documents";
import ClientContact from "pages/client/contact";
import ClientAccountSetting from "pages/client/account-setting";
import ClientNotifications from "pages/client/notifications";
import ClientChatThread from "pages/client/projects/chatThread";
import CollaboratorNotifications from "pages/collaborator/notifications";
import CollaboratorAccountSetting from "pages/collaborator/account-setting";
import CollaboratorContact from "pages/collaborator/contact";
import CollaboratorDocuments from "pages/collaborator/documents";
import CollaboratorProjects from "pages/collaborator/projects";
import CollaboratorArchivedProjects from "pages/collaborator/archivedProjects";
import CollaboratorProjectDetail from "pages/collaborator/projects/projectDetail";
import CollaboratorChatThread from "pages/collaborator/projects/chatThread";
import BuilderProjects from "pages/builder/projects";
import BuilderArchivedProjects from "pages/builder/archivedProjects";
import BuilderProjectDetail from "pages/builder/projects/projectDetail";
import BuilderNotifications from "pages/builder/notifications";
import BuilderAccountSetting from "pages/builder/account-setting";
import BuilderChatThread from "pages/builder/projects/chatThread";
import ResetPassword from "pages/auth/reset-password";
import SetPassword from "pages/auth/set-password";
import DesignerArchivedProjects from "pages/designer/archivedProjects";
import DesignerMyProjects from "pages/designer/myProjects";

const publicRoute: any = [
  {
    path: routeConstant.login.path,
    title: routeConstant.login.title,
    Component: Login,
  },
  {
    path: routeConstant.forgotPassword.path,
    title: routeConstant.forgotPassword.title,
    Component: ForgotPassword,
  },
  {
    path: routeConstant.resetPassword.path,
    title: routeConstant.resetPassword.title,
    Component: ResetPassword,
  },
  {
    path: routeConstant.setPassword.path,
    title: routeConstant.setPassword.title,
    Component: SetPassword,
  },
];

const privateRoute: any = [
  {
    path: routeConstant.onboarding.path,
    title: routeConstant.onboarding.title,
    Component: OnboardingFlow,
  },
  // Designer
  {
    path: routeConstant.designer.home.path,
    title: routeConstant.designer.home.title,
    Component: DesignerHome,
  },
  {
    path: routeConstant.designer.home.uploadRevision.path,
    title: routeConstant.designer.home.uploadRevision.title,
    Component: UploadRevision,
  },
  {
    path: routeConstant.designer.allProjects.path,
    title: routeConstant.designer.allProjects.title,
    Component: DesignerProjects,
  },
  {
    path: routeConstant.designer.myProjects.path,
    title: routeConstant.designer.myProjects.title,
    Component: DesignerMyProjects,
  },
  {
    path: routeConstant.designer.archivedProjects.path,
    title: routeConstant.designer.archivedProjects.title,
    Component: DesignerArchivedProjects,
  },
  {
    path: routeConstant.designer.projectDetail.path,
    title: routeConstant.designer.projectDetail.title,
    Component: DesignerProjectDetail,
  },
  {
    path: routeConstant.designer.projectDetail.thread.path,
    title: routeConstant.designer.projectDetail.thread.title,
    Component: DesignerChatThread,
  },
  {
    path: routeConstant.designer.accountSetting.path,
    title: routeConstant.designer.accountSetting.title,
    Component: DesignerAccountSetting,
  },
  {
    path: routeConstant.designer.notifications.path,
    title: routeConstant.designer.notifications.title,
    Component: DesignerNotifications,
  },

  // Client

  {
    path: routeConstant.client.projects.path,
    title: routeConstant.client.projects.title,
    Component: ClientProjects,
  },
  {
    path: routeConstant.client.archivedProjects.path,
    title: routeConstant.client.archivedProjects.title,
    Component: ClientArchivedProjects,
  },
  {
    path: routeConstant.client.projectDetail.path,
    title: routeConstant.client.projectDetail.title,
    Component: ClientProjectDetail,
  },
  {
    path: routeConstant.client.projectDetail.thread.path,
    title: routeConstant.client.projectDetail.thread.title,
    Component: ClientChatThread,
  },
  {
    path: routeConstant.client.notifications.path,
    title: routeConstant.client.notifications.title,
    Component: ClientNotifications,
  },
  {
    path: routeConstant.client.accountSetting.path,
    title: routeConstant.client.accountSetting.title,
    Component: ClientAccountSetting,
  },
  {
    path: routeConstant.client.contact.path,
    title: routeConstant.client.contact.title,
    Component: ClientContact,
  },
  {
    path: routeConstant.client.documents.path,
    title: routeConstant.client.documents.title,
    Component: ClientDocuments,
  },

  // Collaborator
  {
    path: routeConstant.collaborator.projects.path,
    title: routeConstant.collaborator.projects.title,
    Component: CollaboratorProjects,
  },
  {
    path: routeConstant.collaborator.archivedProjects.path,
    title: routeConstant.collaborator.archivedProjects.title,
    Component: CollaboratorArchivedProjects,
  },
  {
    path: routeConstant.collaborator.projectDetail.path,
    title: routeConstant.collaborator.projectDetail.title,
    Component: CollaboratorProjectDetail,
  },
  {
    path: routeConstant.collaborator.projectDetail.thread.path,
    title: routeConstant.collaborator.projectDetail.thread.title,
    Component: CollaboratorChatThread,
  },
  {
    path: routeConstant.collaborator.notifications.path,
    title: routeConstant.collaborator.notifications.title,
    Component: CollaboratorNotifications,
  },
  {
    path: routeConstant.collaborator.accountSetting.path,
    title: routeConstant.collaborator.accountSetting.title,
    Component: CollaboratorAccountSetting,
  },
  {
    path: routeConstant.collaborator.contact.path,
    title: routeConstant.collaborator.contact.title,
    Component: CollaboratorContact,
  },
  {
    path: routeConstant.collaborator.documents.path,
    title: routeConstant.collaborator.documents.title,
    Component: CollaboratorDocuments,
  },

  // Builder
  {
    path: routeConstant.builder.projects.path,
    title: routeConstant.builder.projects.title,
    Component: BuilderProjects,
  },
  {
    path: routeConstant.builder.archivedProjects.path,
    title: routeConstant.builder.archivedProjects.title,
    Component: BuilderArchivedProjects,
  },
  {
    path: routeConstant.builder.projectDetail.path,
    title: routeConstant.builder.projectDetail.title,
    Component: BuilderProjectDetail,
  },
  {
    path: routeConstant.builder.projectDetail.thread.path,
    title: routeConstant.builder.projectDetail.thread.title,
    Component: BuilderChatThread,
  },
  {
    path: routeConstant.builder.notifications.path,
    title: routeConstant.builder.notifications.title,
    Component: BuilderNotifications,
  },
  {
    path: routeConstant.builder.accountSetting.path,
    title: routeConstant.builder.accountSetting.title,
    Component: BuilderAccountSetting,
  },
];

export { privateRoute, publicRoute };
